<template>
  <div class="aroma-shop aroma-primary-page">
    <header class="aroma-page-header">
      <h1>商城</h1>
      <p>精选助眠产品</p>
    </header>

    <main class="aroma-shop__content">
      <div v-if="loading" class="aroma-page-state">
        <van-loading size="28px">加载中...</van-loading>
      </div>
      <div v-else-if="errorMessage" class="aroma-page-state">
        <van-empty :description="errorMessage">
          <van-button class="aroma-shop__retry" type="primary" size="small" @click="loadProduct">重新加载</van-button>
        </van-empty>
      </div>
      <template v-else-if="product">
        <div class="aroma-section-title">商品列表</div>
        <aroma-product-card
          :product="product"
          :image="detailImage"
          @click="openProduct"
        />
      </template>
    </main>

    <aroma-tabbar />
  </div>
</template>

<script>
import API from '@/api'
import AromaProductCard from '@/components/aroma-report/AromaProductCard.vue'
import AromaTabbar from '@/components/aroma-report/AromaTabbar.vue'
import { AROMA_DETAIL_IMAGE, AROMA_PACKAGE_ID, AROMA_TASK_ID } from '@/utils/aroma-shop'
import { clearSniSession, getSniSession, saveSniSession } from '@/utils/sni-session'

export default {
  name: 'AromaShop',

  components: {
    AromaProductCard,
    AromaTabbar
  },

  data () {
    return {
      loading: false,
      product: null,
      task: null,
      errorMessage: ''
    }
  },

  computed: {
    sn () {
      return this.$route.query.sn || ''
    },

    detailImage () {
      return AROMA_DETAIL_IMAGE
    },

    session () {
      return getSniSession(this.sn)
    }
  },

  mounted () {
    this.loadProduct()
  },

  methods: {
    async loadProduct () {
      this.loading = true
      this.errorMessage = ''
      try {
        const [packageResponse, taskResponse, profile] = await Promise.all([
          API.aromaPackageDetail(AROMA_PACKAGE_ID),
          API.aromaOrderTask(AROMA_TASK_ID),
          API.sniCurrent(this.session.token)
        ])
        if (packageResponse?.code !== '1' || !packageResponse.data) {
          throw new Error(packageResponse?.msg || '商品暂不可用')
        }
        if (taskResponse?.code !== '1' || !taskResponse.data) {
          throw new Error(taskResponse?.msg || '商品暂不可用')
        }
        this.product = packageResponse.data
        this.task = taskResponse.data
        saveSniSession(this.sn, {
          ...this.session,
          profileCompleted: profile.profileCompleted
        })
      } catch (error) {
        if (error?.code === '8' || error?.code === '11') {
          this.handleSessionExpired()
          return
        }
        this.errorMessage = error?.message || '商品暂不可用'
      } finally {
        this.loading = false
      }
    },

    openProduct () {
      if (!this.product || !this.task) return
      this.$router.push({ name: 'AromaProductDetail', query: { sn: this.sn } })
    },

    handleSessionExpired () {
      clearSniSession(this.sn)
      this.$router.replace({
        name: 'AromaReportLogin',
        query: { sn: this.sn, redirect: this.$route.fullPath }
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/assets/css/aroma-commerce.scss';

.aroma-shop {
  &__content {
    padding: 0 12px;
  }

  &__retry {
    background: #596afd;
    border-color: #596afd;
  }
}
</style>
